import script from "./base-component.vue?vue&type=script&lang=js"
export * from "./base-component.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.5.17_webpack@5.97.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"packages/ui-components/src/components/base-component/base-component.vue"]])

export default __exports__